import { render, staticRenderFns } from "./userFeedback.vue?vue&type=template&id=872ab7e0&scoped=true"
import script from "./userFeedback.vue?vue&type=script&lang=js"
export * from "./userFeedback.vue?vue&type=script&lang=js"
import style0 from "./userFeedback.vue?vue&type=style&index=0&id=872ab7e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872ab7e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('872ab7e0')) {
      api.createRecord('872ab7e0', component.options)
    } else {
      api.reload('872ab7e0', component.options)
    }
    module.hot.accept("./userFeedback.vue?vue&type=template&id=872ab7e0&scoped=true", function () {
      api.rerender('872ab7e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedback/userFeedback.vue"
export default component.exports